export const paths = {
    login: '/',
    menu: '/menu',
    ordersStatus: '/orders-status',
    kitchen: '/kitchen',
}